import { applicationSlice } from '../reducers/application-reducer';
export const { changeDrawerState, changelanguage } = applicationSlice.actions;
